import React from 'react';
import update from 'immutability-helper';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import CustomVariables from '../misc/CustomVariables.js';

class MypageAccess extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleUserFieldChange = this.handleUserFieldChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleUserFieldChange(e) {
    const list = [];

    for (const [key, value] of Object.entries(e.target.value)) {
      list.push({
        name: key,
        phone: value
      });
    }

    return this.handleChange(e.target.name, list);
  }

  handleFieldChange(e) {
    return this.handleChange(e.target.name, e.target.value);
  }

  handleChange(name, value) {
    const change = {
      access: {
        json: {}
      }
    };

    change.access.json[name] = {
      $set: value
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  render() {
    const access = this.props.access;

    const users = access.json.users.reduce((res, v) => {
      res[v.name] = v.phone;
      return res;
    }, {});

    return (
      <section className="mf-equipment-equipment">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li className="active">{access.title}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {access.title} <PublishStatusDot entry={access} /><br/>
                  <small>Tilgang</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!this.props.modified || this.props.working}
                >
                  <span>Lagre endringer</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(access.draft || access.updated) || this.props.working || this.props.modified}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={access.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Logg inn som</label>
                <input type="text" className="form-control" name="login" defaultValue={access.json.login} onChange={this.handleFieldChange} />
              </div>
              <div className="form-group">
                <label>Personer</label>
                <CustomVariables
                  keyFormat={(k) => k}
                  valueFormat={(v) => v}
                  variables={users}
                  name="users"
                  onSave={this.handleUserFieldChange}
                />
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default MypageAccess;
